export const INSTRUCTORS = { ken: 'Ken', bryn: 'Bryn', both: 'Ken & Bryn together', either: 'Either instructor' };
export const STATUSES = { new: 'New', waiting: 'Waiting for schedule', ready: 'Ready to contact', contacted: 'Contacted', invited: 'Booking link sent', booked: 'Booked', closed: 'Closed' };
export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const EMPTY_REQUEST = { name: '', email: '', kind: 'event', event_id: '', instructor: '', lesson_count: 1, partner_name: '', details: '', local_days: [], preferred_times: '', recurring_interest: false, source: 'In person', website: '' };

export function dateLabel(value) {
  if (!value) return '';
  return new Date(`${value.slice(0, 10)}T12:00:00Z`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}
export function eventLabel(event) {
  return `${event.name} · ${dateLabel(event.startDate)}–${dateLabel(event.endDate)}${event.location ? ` · ${event.location}` : ''}`;
}
export function localToday() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
export function isOverdue(request, today = localToday()) {
  return Boolean(request.follow_up_on && request.follow_up_on < today && !['booked', 'closed'].includes(request.status));
}
export function validCalendlyLink(value) {
  if (!value) return true;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname === 'calendly.com' && !url.username && !url.password && !url.port && url.pathname.length > 1;
  } catch { return false; }
}
export function eventBookingAvailable(request, settings, host) {
  return request.kind === 'event' && request.instructor !== 'both'
    && ['ken', 'bryn'].includes(host) && (request.instructor === 'either' || request.instructor === host)
    && settings?.event_key === request.event_key && Boolean(settings?.[`${host}_booking_open`])
    && Boolean(settings?.[`calendly_${host}`]) && validCalendlyLink(settings[`calendly_${host}`])
    && (!request.event_end || request.event_end >= localToday());
}
export function invitationDraft(request, url, host) {
  if (request.kind !== 'event' || request.instructor === 'both' || !['ken', 'bryn'].includes(host)) return directFollowUpDraft(request);
  return `Hi ${request.name},\n\n${INSTRUCTORS[host]} has lesson availability at ${request.event_name}! You can choose a time for a 45-minute private lesson with ${INSTRUCTORS[host]} here:\n\n${url}\n\nThis page is for ${request.event_name}${request.event_start ? ` (${dateLabel(request.event_start)}–${dateLabel(request.event_end)})` : ''}. Please check the event, location, and time zone before booking. If this event is no longer available, reply to us so we can help. Your lesson is confirmed once you complete your Calendly booking.\n\nKen & Bryn`;
}
export function directFollowUpDraft(request) {
  const introduction = request.kind === 'local'
    ? 'Thanks for requesting a local private lesson. Let’s arrange a day and time directly.'
    : `Thanks for requesting a private lesson with both of us at ${request.event_name}. We’ll coordinate our schedules together.`;
  const preferences = request.kind === 'local'
    ? [request.local_days?.length ? `Preferred days: ${request.local_days.join(', ')}.` : '', request.preferred_times ? `Preferred dates or times: ${request.preferred_times}.` : ''].filter(Boolean).join('\n')
    : '';
  return `Hi ${request.name},\n\n${introduction}\n\n${preferences ? `${preferences}\n\n` : ''}Please let us know which dates and times work for you. We’ll confirm the time and location with you before the lesson is booked.\n\nKen & Bryn`;
}
